import React, { useEffect } from "react";
import { useState } from "react";
import {
  KeyboardArrowDownRounded,
  KeyboardArrowUpRounded,
} from "@mui/icons-material";
import {
  Button,
  Card,
  Collapse,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { getWorkingStatus } from "../../../../redux/reducer/workingStatus/workingStatusReducer";
import { getJobPosition } from "../../../../redux/reducer/jobPosition/jobPositionReducer";
import { getWorkingArea } from "../../../../redux/reducer/workingArea/workingAreaReducer";
import { getBank } from "../../../../redux/reducer/bank/bankReducer";
import { toast, ToastContainer } from "react-toastify";
import {
  employeeActions,
  getEmployeeById,
  updateEmployee,
} from "../../../../redux/reducer/employee/employeeReducer";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import NumberFormatting from "../../../helper/NumberFormatting";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    border: "1px solid #386E5B",
    textAlign: "center",
  },
  tableCell: {
    padding: "5px 0px",
    border: "1px solid #386E5B",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function AdminEmployeeEdit() {
  // Navigate
  const id = useParams();
  const navigate = useNavigate();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const employee = useSelector((state) => state.employee.data);
  const workingStatus = useSelector((state) => state.workingStatus.data);
  const workingArea = useSelector((state) => state.workingArea.data);
  const jobPosition = useSelector((state) => state.jobPosition.data);
  const bank = useSelector((state) => state.bank.data);

  // Local State
  const [formData, setFormData] = useState({
    employeeCode: "",
    ktpNumber: "",
    fullName: "",
    placeOfBirth: "",
    dateOfBirth: "",
    phoneNumber: "",
    address: "",
    joinDate: "",
    workingStatusId: "",
    workingAreaId: "",
    jobPositionId: "",
    basicSalary: "",
    transportMoney: "",
    rentMoney: "",
    mealAllowance: "",
    bankId: "",
    accountNumber: "",
    accountName: "",
  });
  const [educationalStatement, setEducationalStatement] = useState([]);
  const [familyStatement, setFamilyStatement] = useState([]);
  const [fetch, setFetch] = useState(true);
  const [cardsSetting, setCardsSetting] = useState({
    informasiPribadi: true,
    dataKeluargaPendidikan: false,
    statusPekerjaan: false,
    dataPenggajian: false,
    dataBank: false,
  });

  // Column
  const familyColumn = ["Nama", "Hubungan", "Aksi"];
  const educationColumn = ["Tingkat", "Nama Pendidikan", "Tahun", "Aksi"];

  useEffect(() => {
    if (fetch) {
      const x = employee.docs.findIndex((item) => item._id === id.id);
      if (x > -1) {
        setFamilyStatement([...employee.docs[x].familyStatement]);
        setEducationalStatement([...employee.docs[x].educationalStatement]);
        setFormData({
          employeeCode: employee.docs[x].employeeCode
            ? employee.docs[x].employeeCode
            : "",
          ktpNumber: employee.docs[x].ktpNumber
            ? employee.docs[x].ktpNumber
            : "",
          fullName: employee.docs[x].fullName ? employee.docs[x].fullName : "",
          placeOfBirth: employee.docs[x].birthDate
            ? employee.docs[x].birthDate.placeOfBirth
            : "",
          dateOfBirth: employee.docs[x].birthDate
            ? employee.docs[x].birthDate.dateOfBirth
            : "",
          phoneNumber: employee.docs[x].phoneNumber
            ? employee.docs[x].phoneNumber
            : "",
          address: employee.docs[x].address ? employee.docs[x].address : "",
          joinDate: employee.docs[x].workingDate
            ? employee.docs[x].workingDate.joinDate
            : "",
          workingStatusId: employee.docs[x].workingDate
            ? employee.docs[x].workingDate.workingStatusId._id
            : "",
          workingStatusName: employee.docs[x].workingDate
            ? employee.docs[x].workingDate.workingStatusId.statusName
            : "",
          workingAreaId: employee.docs[x].workingAreaId
            ? employee.docs[x].workingAreaId._id
            : "",
          workingAreaName: employee.docs[x].workingAreaId
            ? employee.docs[x].workingAreaId.areaName
            : "",
          jobPositionId: employee.docs[x].jobPositionId
            ? employee.docs[x].jobPositionId._id
            : "",
          jobPositionName: employee.docs[x].jobPositionId
            ? employee.docs[x].jobPositionId.positionName
            : "",
          basicSalary: employee.docs[x].financialStatement[0]
            ? employee.docs[x].financialStatement[0].basicSalary
            : "",
          transportMoney: employee.docs[x].financialStatement[0]
            ? employee.docs[x].financialStatement[0].transportMoney
            : "",
          rentMoney: employee.docs[x].financialStatement[0]
            ? employee.docs[x].financialStatement[0].rentMoney
            : "",
          mealAllowance: employee.docs[x].financialStatement[0]
            ? employee.docs[x].financialStatement[0].mealAllowance
            : "",
          bankId: employee.docs[x].bankAccount.bankId
            ? employee.docs[x].bankAccount.bankId._id
            : "",
          bankName: employee.docs[x].bankAccount.bankId
            ? employee.docs[x].bankAccount.bankId.bankName
            : "",
          accountNumber: employee.docs[x].bankAccount
            ? employee.docs[x].bankAccount.accountNumber
            : "",
          accountName: employee.docs[x].bankAccount
            ? employee.docs[x].bankAccount.accountName
            : "",
        });
      } else {
        toast.error("Data tidak ditemukan");
      }
      setFetch(false);
    }
  }, [fetch]);

  // Basic Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handling Family
  const handleFamily = (index) => (e) => {
    const newItems = [...familyStatement];
    newItems[index][e.target.name] = e.target.value;
    setFamilyStatement(newItems);
  };

  const handleAddFamily = () => {
    setFamilyStatement((prevItems) => [
      ...prevItems,
      {
        familyName: "",
        familyRelation: "",
      },
    ]);
  };

  const handleDeleteFamily = (value) => {
    let deletedData = [];
    for (let i = 0; i < familyStatement.length; i++) {
      if (i !== value) {
        deletedData.push(familyStatement[i]);
      }
    }
    setFamilyStatement(deletedData);
  };

  // Handling Education
  const handleEducation = (index) => (e) => {
    const newItems = [...educationalStatement];
    newItems[index][e.target.name] = e.target.value;
    setEducationalStatement(newItems);
  };

  const handleAddEducation = () => {
    setEducationalStatement((prevItems) => [
      ...prevItems,
      {
        educationalLevel: "",
        educationalName: "",
        educationalYear: "",
      },
    ]);
  };

  const handleDeleteEducation = (value) => {
    let deletedData = [];
    for (let i = 0; i < educationalStatement.length; i++) {
      if (i !== value) {
        deletedData.push(educationalStatement[i]);
      }
    }
    setEducationalStatement(deletedData);
  };

  const handleCollapse = (val) => {
    switch (val) {
      case 1:
        setCardsSetting({
          ...cardsSetting,
          informasiPribadi: !cardsSetting.informasiPribadi,
        });
        break;
      case 2:
        setCardsSetting({
          ...cardsSetting,
          dataKeluargaPendidikan: !cardsSetting.dataKeluargaPendidikan,
        });
        break;
      case 3:
        setCardsSetting({
          ...cardsSetting,
          statusPekerjaan: !cardsSetting.statusPekerjaan,
        });
        break;
      case 4:
        setCardsSetting({
          ...cardsSetting,
          dataPenggajian: !cardsSetting.dataPenggajian,
        });
        break;
      case 5:
        setCardsSetting({ ...cardsSetting, dataBank: !cardsSetting.dataBank });
        break;
      default:
        break;
    }
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (
        workingStatus.totalDocs !== workingStatus.docs.length &&
        value === 1
      ) {
        const getData = {
          params: {
            limit: workingStatus.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getWorkingStatus(getData));
      } else if (
        jobPosition.totalDocs !== jobPosition.docs.length &&
        value === 2
      ) {
        const getData = {
          params: {
            limit: jobPosition.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getJobPosition(getData));
      } else if (
        workingArea.totalDocs !== workingArea.docs.length &&
        value === 3
      ) {
        const getData = {
          params: {
            limit: workingArea.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getWorkingArea(getData));
      } else if (bank.totalDocs !== bank.docs.length && value === 4) {
        const getData = {
          params: {
            limit: bank.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getBank(getData));
      }
    }
  };

  const handleSubmit = (value) => (event) => {
    event.preventDefault();
    switch (value) {
      case 1:
        setCardsSetting({
          informasiPribadi: false,
          dataKeluargaPendidikan: true,
          statusPekerjaan: false,
          dataPenggajian: false,
          dataBank: false,
        });
        break;
      case 2:
        setCardsSetting({
          informasiPribadi: false,
          dataKeluargaPendidikan: false,
          statusPekerjaan: true,
          dataPenggajian: false,
          dataBank: false,
        });
        break;
      case 3:
        setCardsSetting({
          informasiPribadi: false,
          dataKeluargaPendidikan: false,
          statusPekerjaan: false,
          dataPenggajian: true,
          dataBank: false,
        });
        break;
      case 4:
        setCardsSetting({
          informasiPribadi: false,
          dataKeluargaPendidikan: false,
          statusPekerjaan: false,
          dataPenggajian: false,
          dataBank: true,
        });
        break;
      default:
        break;
    }
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          value: {
            employeeCode: formData.employeeCode,
            ktpNumber: formData.ktpNumber,
            fullName: formData.fullName,
            address: formData.address,
            phoneNumber: formData.phoneNumber,
            birthDate: {
              dateOfBirth: formData.dateOfBirth,
              placeOfBirth: formData.placeOfBirth,
            },
            educationalStatement: educationalStatement,
            familyStatement: familyStatement,
            workingDate: {
              joinDate: formData.joinDate,
              workingStatusId: formData.workingStatusId,
            },
            jobPositionId: formData.jobPositionId,
            workingAreaId: formData.workingAreaId,
            financialStatement: {
              basicSalary: formData.basicSalary,
              transportMoney: formData.transportMoney,
              rentMoney: formData.rentMoney,
              mealAllowance: formData.mealAllowance,
            },
            bankAccount: {
              bankId: formData.bankId,
              accountNumber: formData.accountNumber,
              accountName: formData.accountName,
            },
          },
          token: token,
          id: id.id,
        };
        dispatch(updateEmployee(data)).then((res) => {
          if (res.payload.status === 200) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getEmployeeById(dataGetById)).then((result) => {
              dispatch(employeeActions.editEmployee(result.payload.data));
              toast.success(res.payload.message);
              navigate("/admin/karyawan");
            });
          }
        });
      } else {
        return;
      }
    });
  };

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          EDIT KARYAWAN
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          minWidth={"100%"}
        >
          <Grid items>
            <Typography fontSize={16} color={"#2D6B56"} variant="h6">
              INFORMASI PRIBADI
            </Typography>
          </Grid>
          <Grid
            items
            style={{
              display: "flex",
              alignItems: "center",
              borderRadius: "50px",
              background: "#386e5b",
              color: "white",
            }}
          >
            {!cardsSetting.informasiPribadi ? (
              <KeyboardArrowDownRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(1)}
              />
            ) : (
              <KeyboardArrowUpRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(1)}
              />
            )}
          </Grid>
        </Grid>
        <Divider className={styles.dividerStyle} />

        <Collapse style={{ width: "100%" }} in={cardsSetting.informasiPribadi}>
          <form
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
            onSubmit={handleSubmit(1)}
          >
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                margin: "10px 0px",
                flexDirection: "row",
                background: "none",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                KODE KARYAWAN
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  maxLength: 20,
                  style: { background: "white" },
                  readOnly: true,
                }}
                required
                helperText={
                  formData.employeeCode.length > 0
                    ? /^[A-Za-z]{3}-\d{5}/.test(formData.employeeCode)
                      ? ""
                      : "*Format Kode Karyawan salah"
                    : ""
                }
                size="small"
                error={
                  formData.employeeCode.length > 0
                    ? /^[A-Za-z]{3}-\d{5}/.test(formData.employeeCode)
                      ? false
                      : true
                    : false
                }
                name="employeeCode"
                onChange={handleChange}
                value={formData.employeeCode}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
                background: "none",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                NO KTP
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                size="small"
                error={/^[0-9]*$/.test(formData.ktpNumber) ? false : true}
                helperText={
                  /^[0-9]*$/.test(formData.ktpNumber)
                    ? ""
                    : "*Formart No KTP salah"
                }
                inputProps={{ maxLength: 16, style: { background: "white" } }}
                name="ktpNumber"
                onChange={handleChange}
                value={formData.ktpNumber}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                marginBottom: "10px",
                width: "100%",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                NAMA LENGKAP
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{ maxLength: 50 }}
                required
                size="small"
                error={false}
                name="fullName"
                onChange={handleChange}
                value={formData.fullName}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                marginBottom: "10px",
                width: "100%",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                TEMPAT & TANGGAL LAHIR
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                size="small"
                error={false}
                onChange={handleChange}
                value={formData.placeOfBirth}
                name="placeOfBirth"
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "190px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                size="small"
                type="date"
                error={false}
                onChange={handleChange}
                value={formData.dateOfBirth}
                name="dateOfBirth"
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "200px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                marginBottom: "10px",
                width: "100%",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                NO TELP
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{ maxLength: 20, style: { background: "white" } }}
                required
                type="tel"
                size="small"
                error={/^[0-9]*$/.test(formData.phoneNumber) ? false : true}
                helperText={
                  /^[0-9]*$/.test(formData.phoneNumber)
                    ? ""
                    : "*Formart No Telepon salah"
                }
                name="phoneNumber"
                onChange={handleChange}
                value={formData.phoneNumber}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                marginBottom: "10px",
                width: "100%",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                ALAMAT
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                size="small"
                inputProps={{ maxLength: 250 }}
                error={false}
                name="address"
                onChange={handleChange}
                value={formData.address}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <div className={styles.footerButton}>
              <Button type="submit" variant="contained">
                NEXT
              </Button>
            </div>
          </form>
        </Collapse>
      </Card>
      <Card className={styles.headerClass}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          minWidth={"100%"}
        >
          <Grid items>
            <Typography fontSize={16} color={"#2D6B56"} variant="h6">
              DATA KELUARGA DAN PENDIDIKAN
            </Typography>
          </Grid>
          <Grid
            items
            style={{
              display: "flex",
              alignItems: "center",
              borderRadius: "50px",
              background: "#386e5b",
              color: "white",
            }}
          >
            {!cardsSetting.dataKeluargaPendidikan ? (
              <KeyboardArrowDownRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(2)}
              />
            ) : (
              <KeyboardArrowUpRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(2)}
              />
            )}
          </Grid>
        </Grid>
        <Divider className={styles.dividerStyle} />
        <Collapse
          style={{ width: "100%" }}
          in={cardsSetting.dataKeluargaPendidikan}
        >
          <form style={{ width: "100%" }} onSubmit={handleSubmit(2)}>
            <Typography marginTop={1}>Data Keluarga Karyawan :</Typography>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "10px",
              }}
            >
              <thead>
                {familyColumn.map((item, index) => {
                  return (
                    <td className={styles.tableHeader} key={index}>
                      {item}
                    </td>
                  );
                })}
              </thead>
              <tbody>
                {familyStatement.length > 0 &&
                  familyStatement.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              error={false}
                              name="familyName"
                              inputProps={{ maxLength: 50 }}
                              id={index}
                              onChange={handleFamily(index)}
                              value={item.familyName}
                              variant="outlined"
                              fullWidth
                              style={{
                                maxWidth: "400px",
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              inputProps={{ maxLength: 25 }}
                              error={false}
                              name="familyRelation"
                              id={index}
                              onChange={handleFamily(index)}
                              value={item.familyRelation}
                              variant="outlined"
                              fullWidth
                              style={{
                                maxWidth: "400px",
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                        <td className={styles.tableCell}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              margin: "auto",
                              width: "100px",
                            }}
                          >
                            <AddIcon
                              className={styles.actionButtonEdit}
                              onClick={() => handleAddFamily()}
                            />
                            {familyStatement.length > 1 && index !== 0 ? (
                              <RemoveIcon
                                className={styles.actionButtonEdit}
                                onClick={() => handleDeleteFamily(index)}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <Typography marginTop={2}>Data Pendidikan Karyawan :</Typography>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "10px",
              }}
            >
              <thead>
                {educationColumn.map((item, index) => {
                  return (
                    <td className={styles.tableHeader} key={index}>
                      {item}
                    </td>
                  );
                })}
              </thead>
              <tbody>
                {educationalStatement.length > 0 &&
                  educationalStatement.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              error={false}
                              inputProps={{ maxLength: 25 }}
                              name="educationalLevel"
                              id={index}
                              onChange={handleEducation(index)}
                              value={item.educationalLevel}
                              variant="outlined"
                              fullWidth
                              style={{
                                maxWidth: "400px",
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              error={false}
                              name="educationalName"
                              inputProps={{ maxLength: 50 }}
                              id={index}
                              onChange={handleEducation(index)}
                              value={item.educationalName}
                              variant="outlined"
                              fullWidth
                              style={{
                                maxWidth: "400px",
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ style: { background: "white" } }}
                              required
                              error={
                                educationalStatement[index].educationalYear
                                  .length > 0
                                  ? /^(19|20)\d{2}$/.test(
                                      educationalStatement[index]
                                        .educationalYear
                                    )
                                    ? false
                                    : true
                                  : false
                              }
                              helperText={
                                educationalStatement[index].educationalYear
                                  .length > 0
                                  ? /^(19|20)\d{2}$/.test(
                                      educationalStatement[index]
                                        .educationalYear
                                    )
                                    ? ""
                                    : "*Tanggal tidak valid"
                                  : ""
                              }
                              size="small"
                              name="educationalYear"
                              id={index}
                              onChange={handleEducation(index)}
                              value={item.educationalYear}
                              variant="outlined"
                              fullWidth
                              style={{
                                maxWidth: "400px",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                        <td className={styles.tableCell}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              margin: "auto",
                              width: "100px",
                            }}
                          >
                            <AddIcon
                              className={styles.actionButtonEdit}
                              onClick={() => handleAddEducation()}
                            />
                            {familyStatement.length > 1 && index !== 0 ? (
                              <RemoveIcon
                                className={styles.actionButtonEdit}
                                onClick={() => handleDeleteEducation(index)}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <div className={styles.footerButton}>
              <Button variant="contained" type="submit">
                NEXT
              </Button>
            </div>
          </form>
        </Collapse>
      </Card>
      <Card className={styles.headerClass}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          minWidth={"100%"}
        >
          <Grid items>
            <Typography fontSize={16} color={"#2D6B56"} variant="h6">
              STATUS PEKERJAAN
            </Typography>
          </Grid>
          <Grid
            items
            style={{
              display: "flex",
              alignItems: "center",
              borderRadius: "50px",
              background: "#386e5b",
              color: "white",
            }}
          >
            {!cardsSetting.statusPekerjaan ? (
              <KeyboardArrowDownRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(3)}
              />
            ) : (
              <KeyboardArrowUpRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(3)}
              />
            )}
          </Grid>
        </Grid>
        <Divider className={styles.dividerStyle} />
        <Collapse style={{ width: "100%" }} in={cardsSetting.statusPekerjaan}>
          <form
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
            onSubmit={handleSubmit(3)}
          >
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                TANGGAL MASUK
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                size="small"
                error={false}
                onChange={handleChange}
                value={formData.joinDate}
                type="date"
                name="joinDate"
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                STATUS KARYAWAN
              </Typography>
              <TextField
                select
                InputLabelProps={{ shrink: true }}
                required
                size="small"
                error={false}
                name="workingStatusId"
                onChange={handleChange}
                value={formData.workingStatusId}
                fullWidth
                variant="outlined"
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      onScroll: loadMore(1),
                    },
                    style: {
                      height: "300px",
                    },
                  },
                }}
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              >
                {formData.workingStatusName &&
                formData.workingStatusId.length > 0 ? (
                  <MenuItem value={formData.workingStatusId}>
                    {formData.workingStatusName}
                  </MenuItem>
                ) : (
                  <MenuItem value="">Pilih Status Karyawan</MenuItem>
                )}
                {workingStatus.docs.length > 0 ? (
                  workingStatus.docs.map(
                    (data, index) =>
                      (
                        <MenuItem value={data._id} key={index}>
                          {data.statusName}
                        </MenuItem>
                      )
                  )
                ) : (
                  <MenuItem value="">Data kosong</MenuItem>
                )}
              </TextField>
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                JABATAN
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                select
                required
                size="small"
                error={false}
                name="jobPositionId"
                onChange={handleChange}
                value={formData.jobPositionId}
                fullWidth
                variant="outlined"
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      onScroll: loadMore(2),
                    },
                    style: {
                      height: "300px",
                    },
                  },
                }}
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              >
                {formData.jobPositionName &&
                formData.jobPositionId.length > 0 ? (
                  <MenuItem value={formData.jobPositionId}>
                    {formData.jobPositionName}
                  </MenuItem>
                ) : (
                  <MenuItem value="">Pilih Posisi/Jabatan Karyawan</MenuItem>
                )}
                {jobPosition.docs.length > 0 ? (
                  jobPosition.docs.map(
                    (data, index) =>
                      (
                        <MenuItem value={data._id} key={index}>
                          {data.positionName}
                        </MenuItem>
                      )
                  )
                ) : (
                  <MenuItem value="">Data kosong</MenuItem>
                )}
              </TextField>
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                AREA
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                select
                required
                size="small"
                error={false}
                name="workingAreaId"
                onChange={handleChange}
                value={formData.workingAreaId}
                fullWidth
                variant="outlined"
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      onScroll: loadMore(3),
                    },
                    style: {
                      height: "300px",
                    },
                  },
                }}
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              >
                {formData.workingAreaName &&
                formData.workingAreaId.length > 0 ? (
                  <MenuItem value={formData.workingAreaId}>
                    {formData.workingAreaName}
                  </MenuItem>
                ) : (
                  <MenuItem value="">Pilih Area Kerja Karyawan</MenuItem>
                )}
                {workingArea.docs.length > 0 ? (
                  workingArea.docs.map(
                    (data, index) =>
                      (
                        <MenuItem value={data._id} key={index}>
                          {data.areaName}
                        </MenuItem>
                      )
                  )
                ) : (
                  <MenuItem value="">Data kosong</MenuItem>
                )}
              </TextField>
            </FormControl>
            <div className={styles.footerButton}>
              <Button variant="contained" type="submit">
                NEXT
              </Button>
            </div>
          </form>
        </Collapse>
      </Card>
      <Card className={styles.headerClass}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          minWidth={"100%"}
        >
          <Grid items>
            <Typography fontSize={16} color={"#2D6B56"} variant="h6">
              DATA PENGGAJIAN
            </Typography>
          </Grid>
          <Grid
            items
            style={{
              display: "flex",
              alignItems: "center",
              borderRadius: "50px",
              background: "#386e5b",
              color: "white",
            }}
          >
            {!cardsSetting.dataPenggajian ? (
              <KeyboardArrowDownRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(4)}
              />
            ) : (
              <KeyboardArrowUpRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(4)}
              />
            )}
          </Grid>
        </Grid>
        <Divider className={styles.dividerStyle} />
        <Collapse style={{ width: "100%" }} in={cardsSetting.dataPenggajian}>
          <form
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
            onSubmit={handleSubmit(4)}
          >
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                GAJI POKOK
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                inputProps={{
                  style: { background: "white", paddingLeft: "5px" },
                }}
                InputProps={{
                  inputComponent: NumberFormatting,
                  startAdornment: (
                    <InputAdornment position="start">Rp. </InputAdornment>
                  ),
                }}
                size="small"
                error={false}
                onChange={handleChange}
                value={formData.basicSalary}
                name="basicSalary"
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                UANG TRANSPORT
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                inputProps={{
                  style: { background: "white", paddingLeft: "5px" },
                }}
                InputProps={{
                  inputComponent: NumberFormatting,
                  startAdornment: (
                    <InputAdornment position="start">Rp. </InputAdornment>
                  ),
                }}
                size="small"
                error={false}
                name="transportMoney"
                onChange={handleChange}
                value={formData.transportMoney}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                UANG MAKAN
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                inputProps={{
                  style: { background: "white", paddingLeft: "5px" },
                }}
                InputProps={{
                  inputComponent: NumberFormatting,
                  startAdornment: (
                    <InputAdornment position="start">Rp. </InputAdornment>
                  ),
                }}
                size="small"
                error={false}
                name="mealAllowance"
                onChange={handleChange}
                value={formData.mealAllowance}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                LIMIT PINJAMAN
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                inputProps={{
                  style: { background: "white", paddingLeft: "5px" },
                }}
                InputProps={{
                  inputComponent: NumberFormatting,
                  startAdornment: (
                    <InputAdornment position="start">Rp. </InputAdornment>
                  ),
                }}
                size="small"
                error={false}
                name="rentMoney"
                onChange={handleChange}
                value={formData.rentMoney}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <div className={styles.footerButton}>
              <Button variant="contained" type="submit">
                NEXT
              </Button>
            </div>
          </form>
        </Collapse>
      </Card>
      <Card className={styles.headerClass}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          minWidth={"100%"}
        >
          <Grid items>
            <Typography fontSize={16} color={"#2D6B56"} variant="h6">
              DATA BANK
            </Typography>
          </Grid>
          <Grid
            items
            style={{
              display: "flex",
              alignItems: "center",
              borderRadius: "50px",
              background: "#386e5b",
              color: "white",
            }}
          >
            {!cardsSetting.dataBank ? (
              <KeyboardArrowDownRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(5)}
              />
            ) : (
              <KeyboardArrowUpRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(5)}
              />
            )}
          </Grid>
        </Grid>
        <Divider className={styles.dividerStyle} />
        <Collapse style={{ width: "100%" }} in={cardsSetting.dataBank}>
          <form
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
            onSubmit={handleSubmitAll}
          >
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                PILIH BANK
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                select
                size="small"
                error={false}
                name="bankId"
                onChange={handleChange}
                value={formData.bankId}
                fullWidth
                variant="outlined"
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      onScroll: loadMore(4),
                    },
                    style: {
                      height: "300px",
                    },
                  },
                }}
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              >
                {formData.bankName && formData.bankId.length > 0 ? (
                  <MenuItem value={formData.bankId}>
                    {formData.bankName}
                  </MenuItem>
                ) : (
                  <MenuItem value="">Pilih Bank</MenuItem>
                )}
                {bank.docs.length > 0 ? (
                  bank.docs.map(
                    (data, index) =>
                      (
                        <MenuItem value={data._id} key={index}>
                          {data.bankName}
                        </MenuItem>
                      )
                  )
                ) : (
                  <MenuItem value="">Data kosong</MenuItem>
                )}
              </TextField>
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                NO REKENING
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{ style: { background: "white" } }}
                required
                size="small"
                error={/^[0-9]*$/.test(formData.accountNumber) ? false : true}
                helperText={
                  /^[0-9]*$/.test(formData.accountNumber)
                    ? ""
                    : "*No Rekening tidak valid"
                }
                name="accountNumber"
                onChange={handleChange}
                value={formData.accountNumber}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                NAMA REKENING
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                size="small"
                inputProps={{ maxLength: 50 }}
                error={false}
                name="accountName"
                onChange={handleChange}
                value={formData.accountName}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <div className={styles.footerButton}>
              <Button variant="contained" type="submit">
                SUBMIT
              </Button>
              <Button
                variant="contained"
                color="error"
                style={{ marginLeft: "10px" }}
                onClick={() => navigate("/admin/karyawan")}
              >
                KEMBALI
              </Button>
            </div>
          </form>
        </Collapse>
      </Card>
    </Grid>
  );
}
